/**
 * Log levels ordered by verbosity (higher = more verbose).
 *
 * Setting Logger.level to a value shows all messages at that level and below:
 *   NONE  = 0 → nothing
 *   ERROR = 1 → errors only
 *   WARN  = 2 → warnings + errors
 *   LOG   = 3 → logs + warnings + errors
 *   DEBUG = 4 → everything
 */
export enum LogLevel {
    NONE = 0,
    ERROR = 1,
    WARN = 2,
    LOG = 3,
    DEBUG = 4,
}

export class Logger {
    // Default to ERROR so errors always surface in the console.
    // Set logger="enabled" on trace-viewer element for full logging (DEBUG).
    // Set logger="log" for load/scene milestones without per-object debug.
    // Set logger="warn" for warnings + errors.
    public static level: LogLevel = LogLevel.ERROR;

    static debug(message: string, ...optionalParams: unknown[]): void {
        if (this.level >= LogLevel.DEBUG) {
            console.debug(`[DEBUG]: ${message}`, ...optionalParams);
        }
    }

    static log(message: string, ...optionalParams: unknown[]): void {
        if (this.level >= LogLevel.LOG) {
            console.log(`[LOG]: ${message}`, ...optionalParams);
        }
    }

    static warn(message: string, ...optionalParams: unknown[]): void {
        if (this.level >= LogLevel.WARN) {
            console.warn(`[WARN]: ${message}`, ...optionalParams);
        }
    }

    static error(message: string, ...optionalParams: unknown[]): void {
        if (this.level >= LogLevel.ERROR) {
            console.error(`[ERROR]: ${message}`, ...optionalParams);
        }
    }
}